module.exports = __webpack_public_path__ + "static/media/steve-sosa-child.5721d492.jpg";